import types from '../mutation-types';
import PromptTemplatesAPI from '../../api/promptTemplates';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
    },
};

export const getters = {
    getTemplates($state) {
        return $state.records;
    },
    getUIFlags($state) {
        return $state.uiFlags;
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_PROMPT_TEMPLATES_UI_FLAG, { isFetching: true });
        try {
            const response = await PromptTemplatesAPI.get();
            commit(types.SET_PROMPT_TEMPLATES, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_PROMPT_TEMPLATES_UI_FLAG, { isFetching: false });
        }
    },
};

export const mutations = {
    [types.SET_PROMPT_TEMPLATES_UI_FLAG]($state, data) {
        $state.uiFlags = {
            ...$state.uiFlags,
            ...data,
        };
    },
    [types.SET_PROMPT_TEMPLATES]($state, data) {
        $state.records = data;
    },
};

export default {
    namespaced: true,
    actions,
    state,
    getters,
    mutations,
};
